
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'

import 'dayjs/locale/de'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'


dayjs.extend(updateLocale)

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.tz.setDefault('Europe/Berlin')

// defaultLocale: ["de",{"relativeTime":{"M":"einem Monat","MM":"%d Monaten","d":"einem Tag","dd":"%d Tagen","future":"in %s","h":"einer Stunde","hh":"%d Stunden","m":"einer Minute","mm":"%d Minuten","past":"vor %s","s":"ein paar Sekunden","y":"einem Jahr","yy":"%d Jahren"}}]


dayjs.updateLocale("de",{"relativeTime":{"M":"einem Monat","MM":"%d Monaten","d":"einem Tag","dd":"%d Tagen","future":"in %s","h":"einer Stunde","hh":"%d Stunden","m":"einer Minute","mm":"%d Minuten","past":"vor %s","s":"ein paar Sekunden","y":"einem Jahr","yy":"%d Jahren"}})
dayjs.locale('de')


export default dayjs
